import * as types from "~/store/resource/resourceType";

const emptyCareer = {
  id: 0,
  name: "Chọn nghề nghiệp"
};
const emptyCity = {
  id: 0,
  name: "Chọn tỉnh thành"
};
const defaultVN = {
  code: "VIE",
  id: 203,
  name: "Việt Nam"
};

const emptyDistrict = {
  id: 0,
  name: "Chọn quận huyện"
};
const emptyWard = {
  id: 0,
  name: "Chọn phường xã"
};
const emptyRelationShip = {
  id: 0,
  name: "Chọn quan hệ"
};

const initialState = {
  data: "",
  dataBannerList: [],
  dataHoliday: [],

  dataCareer: [],
  selectedCareer: { ...emptyCareer },

  dataCity: [{ ...emptyCity }],
  selectedCity: { ...emptyCity },

  dataCountry: [],
  selectedCountry: { ...defaultVN },

  dataDistrict: [{ ...emptyDistrict }],
  selectedDistrict: { ...emptyDistrict },

  dataNation: [],
  selectedNation: {},

  dataWard: [],
  selectedWard: { ...emptyWard },

  dataRelationShip: [],
  selectedRelationShip: { ...emptyRelationShip },

  error: "",
  loading: false
};

export default function resource(state = initialState, action) {
  switch (action.type) {
    // TERM OF SERVICE
    case types.GET_TERM_OF_SERVICE_REQUEST: {
      return { ...state, loading: true };
    }
    case types.GET_TERM_OF_SERVICE_SUCCESS: {
      return { ...state, data: action.payload, error: "", loading: false };
    }
    case types.GET_TERM_OF_SERVICE_FAIL: {
      return { ...state, error: action.error, loading: false };
    }

    // INTRODUCTION
    case types.GET_INTRODUCTION_REQUEST: {
      return { ...state, loading: true };
    }
    case types.GET_INTRODUCTION_SUCCESS: {
      return { ...state, loading: false, data: action.payload, error: "" };
    }
    case types.GET_INTRODUCTION_FAIL: {
      return { ...state, loading: false, error: action.error };
    }

    // PRIVATE POLICY
    case types.GET_PRIVATE_POLICY_REQUEST: {
      return { ...state, loading: true };
    }
    case types.GET_PRIVATE_POLICY_SUCCESS: {
      return { ...state, loading: false, data: action.data, error: "" };
    }
    case types.GET_PRIVATE_POLICY_FAIL: {
      return { ...state, loading: false, error: action.error };
    }

    // USAGE RULES
    case types.GET_USAGE_RULES_REQUEST: {
      return { ...state, loading: true };
    }
    case types.GET_USAGE_RULES_SUCCESS: {
      return { ...state, data: action.payload, error: "", loading: false };
    }
    case types.GET_USAGE_RULES_FAIL: {
      return { ...state, error: action.error, loading: false };
    }

    case types.GET_TERM_BEFORE_LOGIN:
      return { ...state, loading: true };
    case types.GET_TERM_BEFORE_LOGIN_SUCCESS:
      return { ...state, data: action.data, error: "", loading: false };
    case types.GET_TERM_BEFORE_LOGIN_FAIL:
      return { ...state, error: action.error, loading: false };

    // GET HOLIDAY
    case types.GET_HOLIDAY_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GET_HOLIDAY_SUCCESS:
      return {
        ...state,
        loading: false,
        dataHoliday: [...action.data]
      };
    case types.GET_HOLIDAY_FAIL:
      return {
        ...state,
        loading: true,
        error: action.error
      };

    // GET BANNER
    case types.GET_BANNER_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GET_BANNER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        dataBannerList: action.data
      };
    case types.GET_BANNER_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.errors
      };

    // SELECT CAREER
    case types.GET_ALL_CAREERS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GET_ALL_CAREERS_SUCCESS:
      return {
        ...state,
        loading: false,
        dataCareer: [{ ...emptyCareer }, ...action.data]
      };
    case types.GET_ALL_CAREERS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.errors
      };
    case types.CHANGE_CAREER:
      return {
        ...state,
        selectedCareer: { ...state.selectedCareer, ...action.selectedCareer }
      };

    // NATION
    case types.GET_ALL_NATION_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GET_ALL_NATION_SUCCESS:
      return {
        ...state,
        loading: false,
        dataNation: action.data
      };
    case types.GET_ALL_NATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.errors
      };
    case types.CHANGE_NATION:
      return {
        ...state,
        selectedNation: { ...state.selectedNation, ...action.selectedNation }
      };

    // COUNTRY
    case types.GET_ALL_COUNTRIES_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GET_ALL_COUNTRIES_SUCCESS:
      return {
        ...state,
        loading: false,
        dataCountry: [...action.data]
      };
    case types.GET_ALL_COUNTRIES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.errors
      };
    case types.CHANGE_COUNTRY:
      return {
        ...state,
        selectedCountry: action.selectedCountry
      };
    case types.RESET_SELECTED_COUNTRY:
      return {
        ...state,
        selectedCountry: { ...defaultVN }
      };

    // CITY
    case types.GET_ALL_CITIES_BY_COUNTRY_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GET_ALL_CITIES_BY_COUNTRY_SUCCESS:
      return {
        ...state,
        loading: false,
        dataCity: [{ ...emptyCity }, ...action.data]
      };
    case types.GET_ALL_CITIES_BY_COUNTRY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.errors
      };
    case types.CHANGE_CITY:
      return {
        ...state,
        selectedCity: { ...state.selectedCity, ...action.selectedCity }
      };
    case types.RESET_CITY:
      return {
        ...state,
        dataCity: [],
        selectedCity: {}
      };

    // DISTRICT
    case types.GET_ALL_DISTRICTS_BY_CITY_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GET_ALL_DISTRICTS_BY_CITY_SUCCESS:
      return {
        ...state,
        loading: false,
        dataDistrict: [{ ...emptyDistrict }, ...action.data]
      };
    case types.GET_ALL_DISTRICTS_BY_CITY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.errors
      };
    case types.CHANGE_DISTRICT:
      return {
        ...state,
        selectedDistrict: {
          ...state.selectedDistrict,
          ...action.selectedDistrict
        }
      };
    case types.RESET_DISTRICT:
      return {
        ...state,
        dataDistrict: [{ ...emptyDistrict }],
        selectedDistrict: { ...emptyDistrict }
      };

    // SELECT WARD
    case types.GET_ALL_WARDS_BY_DISTRICT_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GET_ALL_WARDS_BY_DISTRICT_SUCCESS:
      return {
        ...state,
        loading: false,
        dataWard: [{ ...emptyWard }, ...action.data]
      };
    case types.GET_ALL_WARDS_BY_DISTRICT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.errors
      };
    case types.CHANGE_WARD:
      return {
        ...state,
        selectedWard: { ...state.selectedWard, ...action.selectedWard }
      };
    case types.RESET_WARD:
      return {
        ...state,
        dataWard: [{ ...emptyWard }],
        selectedWard: { ...emptyWard }
      };

    // RELATIONSHIP
    case types.GET_ALL_RELATIONSHIP_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GET_ALL_RELATIONSHIP_SUCCESS:
      return {
        ...state,
        loading: false,
        dataRelationShip: [{ ...emptyRelationShip }, ...action.data]
      };
    case types.GET_ALL_RELATIONSHIP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.errors
      };
    case types.CHANGE_RELATIONSHIP:
      return {
        ...state,
        selectedRelationShip: {
          ...state.selectedRelationShip,
          ...action.selectedRelationShip
        }
      };
    default:
      return state;
  }
}
